import React from "react";
import DataStore from "../services/DataAccess/DataStore";
import ModelTemplateTabView from "./ModelTemplateTabView";

import { Consumer } from "../utilities/LexUtilities";

export default class ModelTemplateContainer extends React.PureComponent {
  componentDidMount() {
    //Fetch data on page load
    DataStore.fetchModelTemplates();
    DataStore.initializeDocuments();
  }

  componentWillUnmount() {
    //Do stuff when navigating away
  }

  //Filter out needed data from DataStore.js
  mapStoreToProps = (store) => {
    return {
      modelTemplates: store.modelTemplates,
      showDropdowns: store.showDropdowns,
      documentMap: store.documentMap,
    };
  };

  render() {
    return (
      <Consumer>
        {(store) => {
          let props = this.mapStoreToProps(store);
          return <ModelTemplateTabView {...props} />;
        }}
      </Consumer>
    );
  }
}
